module.exports = __webpack_public_path__ + "img/rightside_1000.21d88ebe.png";